

















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import DateForm from '@/components/misc/DateForm.vue'
import { ITransactionParams } from '@/services/transactions'
import { GENESIS_TIME } from '@/constants'

@Component({
    components: {
        DateForm,
    },
})
export default class TxParams extends Vue {
    @Prop({ default: 'Search' }) title!: string
    @Prop() chainColor!: string

    startDate: string = new Date().toISOString()
    endDate: string = new Date(GENESIS_TIME).toISOString()
    sort = 'timestamp-desc'
    sorts = [
        {
            label: 'New to Old',
            query: 'timestamp-desc',
        },
        {
            label: 'Old to New',
            query: 'timestamp-asc',
        },
    ]
    limit = 25
    limits = [10, 25, 100, 1000, 5000]

    setStart(val: string) {
        this.startDate = val
    }

    setEnd(val: string) {
        this.endDate = val
    }

    submit() {
        const params: ITransactionParams = {
            sort: this.sort,
            limit: this.limit,
            endTime: Math.round(new Date(this.endDate).getTime() / 1000),
            startTime: Math.round(new Date(this.startDate).getTime() / 1000),
        }

        // params =
        //     this.sort === 'timestamp-desc'
        //         ? {
        //               endTime: Math.round(
        //                   new Date(this.endDate).getTime() / 1000
        //               ),
        //               ...params,
        //           }
        //         : {
        //               startTime: Math.round(
        //                   new Date(this.startDate).getTime() / 1000
        //               ),
        //               ...params,
        //           }

        this.$emit('change', params)
    }

    created() {
        this.$watch('limit', () => {
            this.submit()
        })

        this.$watch('sort', () => {
            this.submit()
        })

        this.$watch('endDate', () => {
            this.submit()
        })

        this.$watch('startDate', () => {
            this.submit()
        })
    }
}
